import React from 'react';
import { Clock } from 'lucide-react';
import PropTypes from 'prop-types';

const ProgressView = ({ translationProgress, translationStatus, translationTask, elapsedTime }) => (
  <div className="h-full flex items-center justify-center">
    <div className="mt-4 text-center text-pl_txt_dark_5 flex items-center justify-center w-full max-w-2xl mx-auto">
      <div className="bg-pl_bg_light_3 p-5 rounded-lg flex flex-col items-center justify-center w-full">
          <div className="w-full bg-pl_bg_dark_2 rounded-full h-4 mb-2">
            <div
              className="bg-pl_prim_color_1 h-4 rounded-full transition-all duration-500 ease-in-out"
              style={{ width: `${translationProgress}%` }}
            ></div>
          <div className="flex justify-between">
            <span className="text-sm text-pl_txt_dark_2">Starting</span>
            <span className="text-sm text-pl_txt_dark_2">Completed</span>
          </div>
        </div>

        <div className="mb-6 flex items-center justify-center">
          <Clock className="mr-2 text-pl_prim_color_1" size={20} />
          <span className="text-lg capitalize">{translationStatus}</span>
          {elapsedTime !== undefined && (
            <span className="ml-4 text-sm text-pl_txt_dark_2">{elapsedTime} seconds elapsed</span>
          )}
        </div>

        <p className="text-sm text-pl_txt_dark_2 mb-4">
          Please wait while your document is being translated. <br />
        </p>

        {translationTask && (
          <p className="text-xs text-pl_txt_dark_3 mb-4">
            Task ID: {translationTask.task_id}
          </p>
        )}
      </div>
    </div>
  </div>
);

ProgressView.propTypes = {
  translationProgress: PropTypes.number.isRequired,
  translationStatus: PropTypes.string.isRequired,
  translationTask: PropTypes.shape({
    task_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  elapsedTime: PropTypes.number,
};

export default ProgressView;
